module.exports = __webpack_public_path__ + "img/lock.6fa0e49c.png";